import { Link } from "react-router-dom";
import { POI_DOT, POI_FILL } from "../shared/mapModel";
import { MarkerIcon } from "../shared/markers";
import { COUNTRIES, HOSTELS, type Poi } from "./content";
import { hostelPath, mmUrl } from "./links";
import { fmtKm, POI_GROUP_LABEL } from "./mapModel";
import { Flag } from "./ui";
import styles from "./PlaceCard.module.scss";

const CloseIcon = () => (
	<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
		<path d="M6 6l12 12M18 6 6 18" stroke="#0f3e4a" strokeWidth="2.4" strokeLinecap="round" />
	</svg>
);

interface HostelCardProps {
	slug: string;
	inRoute: boolean;
	onToggle: () => void;
	onClose: () => void;
}

/** The card of a hostel marker: add it to the route (or take it out), open it on Mad Monkey's own site. */
export const HostelCard = ({ slug, inRoute, onToggle, onClose }: HostelCardProps) => {
	const h = HOSTELS[slug];
	return (
		<>
			<div className={styles.photo}>
				<img src={h.photos[0]} alt={`Mad Monkey ${h.name}`} />
				<span className={styles.country}>
					<Flag cc={h.cc} size={14} />
					{COUNTRIES[h.cc]}
				</span>
				<button type="button" className={styles.close} onClick={onClose} aria-label="Close">
					<CloseIcon />
				</button>
			</div>
			<div className={styles.body}>
				<b>
					<Link to={hostelPath(slug)}>Mad Monkey {h.name}</Link>
				</b>
				<small>{h.tag}</small>
				<div className={styles.row}>
					{inRoute ? (
						<button type="button" className={`${styles.btn} ${styles.in}`} onClick={onToggle}>
							<span className={styles.on}>✓ In your route</span>
							<span className={styles.off}>Remove</span>
						</button>
					) : (
						<button type="button" className={styles.btn} onClick={onToggle}>
							+ Add to route
						</button>
					)}
					<a className={`${styles.btn} ${styles.ghost}`} href={mmUrl(slug)} rel="noopener">
						Hostel ↗
					</a>
				</div>
			</div>
		</>
	);
};

/** The card of a nearby place: what it is, why it is worth the walk, how far it is. */
export const PoiCard = ({ poi, onClose }: { poi: Poi; onClose: () => void }) => (
	<>
		<div className={styles.photo}>
			{poi.photo ? (
				<img src={poi.photo} alt={poi.name} />
			) : (
				<span className={styles.tile} style={{ background: POI_FILL[poi.grp] }}>
					<MarkerIcon name={poi.icon} size={54} />
				</span>
			)}
			<button type="button" className={styles.close} onClick={onClose} aria-label="Close">
				<CloseIcon />
			</button>
		</div>
		<div className={styles.body}>
			<span className={styles.group}>
				<i style={{ background: POI_DOT[poi.grp] }} />
				{POI_GROUP_LABEL[poi.grp]}
			</span>
			<b>{poi.name}</b>
			<small>{fmtKm(poi.dist)} from the hostel</small>
			<p>{poi.why}</p>
		</div>
	</>
);
